import {
    Block as BlockIcon,
    Security as SecurityIcon
} from "@mui/icons-material";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from "@mui/material";
import React from "react";
import { usePagesTranslation } from "../locales";

const BannedWordsSection = ({ embedded = false, sx: rootSx }) => {
    const { t } = usePagesTranslation();
    const bannedWordsCategories = [
        { category: 'profanity', color: '#f44336', descKey: 'landing.bannedWords.profanity-desc' },
        { category: 'violence', color: '#ff5722', descKey: 'landing.bannedWords.violence-desc' },
        { category: 'drugs', color: '#ff9800', descKey: 'landing.bannedWords.drugs-desc' },
        { category: 'offensive', color: '#ffc107', descKey: 'landing.bannedWords.offensive-desc' },
        { category: 'inappropriate', color: '#ff6b6b', descKey: 'landing.bannedWords.inappropriate-desc' },
        { category: 'other', color: '#9e9e9e', descKey: 'landing.bannedWords.other-desc' }
    ];

    const getCategoryLabel = (category) => {
        return t(`landing.bannedWords.${category}`);
    };

    return (
        <Box sx={{ mt: embedded ? 0 : 6, mb: embedded ? 0 : 6, ...rootSx }}>
            {!embedded && (
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <SecurityIcon sx={{ fontSize: 48, color: '#3BA666', mb: 2 }} />
                    <Typography
                        variant="h4"
                        gutterBottom
                        sx={{ fontWeight: 600, mb: 2 }}
                    >
                        {t("landing.bannedWords.title")}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ maxWidth: 700, mx: 'auto', mb: 3 }}
                    >
                        {t("landing.bannedWords.intro")}
                    </Typography>
                </Box>
            )}

            <Grid container spacing={3} sx={{ maxWidth: embedded ? '100%' : 1000, mx: embedded ? 0 : 'auto' }}>
                {bannedWordsCategories.map((category) => (
                    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={category.category}>
                        <Card
                            sx={{
                                height: '100%',
                                transition: 'all 0.3s ease',
                                border: '2px solid',
                                borderColor: category.color,
                                backgroundColor: '#fff',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: 3
                                }
                            }}
                        >
                            <CardContent sx={{ p: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <BlockIcon
                                        sx={{
                                            fontSize: 28,
                                            color: category.color,
                                            mr: 1.5
                                        }}
                                    />
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontWeight: 600,
                                            color: 'text.primary',
                                            fontSize: '1.1rem'
                                        }}
                                    >
                                        {getCategoryLabel(category.category)}
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ lineHeight: 1.6 }}
                                >
                                    {t(category.descKey)}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            <Box sx={{
                mt: 4,
                p: 3,
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                maxWidth: embedded ? '100%' : 800,
                mx: embedded ? 0 : 'auto',
                textAlign: embedded ? 'left' : 'center'
            }}>
                <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
                    ✓ {t("landing.bannedWords.screened")}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t("landing.bannedWords.footer")}
                </Typography>
            </Box>
        </Box>
    );
};

export default BannedWordsSection;

